/* California High: mobile sticky add-to-cart bar (PDP).
   Shows once the on-page Add to cart button has scrolled above the viewport; hides when it is on screen
   or still below the fold. Scroll-driven and throttled with setTimeout (not requestAnimationFrame, which
   pauses in background tabs) so fast scrolls and programmatic jumps cannot leave the bar in the wrong state. */
(function () {
  var initialised = false;

  function setup(bar) {
    var sectionId = bar.dataset.section;
    var pending = false;

    function mainButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function evaluate() {
      pending = false;
      var btn = mainButton();
      if (!btn) return;
      var show = btn.getBoundingClientRect().bottom < 0;
      if (show) {
        bar.hidden = false;
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
        bar.hidden = true;
      }
    }

    function schedule() {
      if (pending) return;
      pending = true;
      setTimeout(evaluate, 40);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    evaluate();
    setTimeout(evaluate, 600);

    var stickyButton = bar.querySelector('.ch-sticky-atc__button');
    if (!stickyButton) return;

    if (stickyButton.dataset.scrollTarget) {
      stickyButton.addEventListener('click', function () {
        var target = document.getElementById(stickyButton.dataset.scrollTarget);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
      return;
    }

    var select = bar.querySelector('.ch-sticky-atc__select');
    var formId = stickyButton.dataset.form;
    if (!select || !formId) return;

    function syncHiddenInput() {
      var form = document.getElementById(formId);
      if (!form) return null;
      var input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = select.value;
        input.disabled = false;
      }
      return form;
    }

    select.addEventListener('change', syncHiddenInput);

    stickyButton.addEventListener('click', function () {
      var form = syncHiddenInput();
      if (!form) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  }

  function init() {
    if (initialised) return;
    initialised = true;
    document.querySelectorAll('.ch-sticky-atc').forEach(setup);
  }

  // DOMContentLoaded can already have fired by the time this deferred script runs, so guard on readyState.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
